(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-custom-fp"] && !Shopify.designMode) return;
  try {
    
  function customFpEscapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function customFpFormatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }

    return '£' + (Number(cents || 0) / 100).toFixed(2) + ' GBP';
  }

  function customFpImageUrl(src) {
    return src || '';
  }

  function customFpImageSrcset(src) {
    if (!src) {
      return '';
    }

    return src + ' 800w';
  }

  function customFpVariantImage(variant, product, allowFallback) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    return allowFallback ? product.featured_image || '' : '';
  }

  function customFpBuildThumb(src, label, active) {
    if (!src) {
      return '';
    }

    return [
      '<button class="custom-fp-card__variant-thumb' + (active ? ' is-active' : '') + '" type="button" aria-label="' + customFpEscapeHtml(label) + '" data-custom-fp-thumb data-image-src="' + customFpEscapeHtml(customFpImageUrl(src)) + '" data-image-srcset="' + customFpEscapeHtml(customFpImageSrcset(src)) + '">',
      '<img src="' + customFpEscapeHtml(src) + '" alt="' + customFpEscapeHtml(label) + '" loading="lazy" width="96" height="96">',
      '</button>'
    ].join('');
  }

  function customFpBuildProductCard(product) {
    var featuredImage = product.featured_image || '';
    var productUrl = product.url || '/products/' + product.handle;
    var compareAtPrice = Number(product.compare_at_price || 0);
    var price = Number(product.price || 0);
    var onSale = compareAtPrice > price;
    var colorOptionIndex = -1;
    var thumbnails = [];
    var seenColors = {};

    (product.options || []).forEach(function(optionName, index) {
      var normalized = String(optionName || '').toLowerCase();
      if (colorOptionIndex === -1 && (normalized.indexOf('color') !== -1 || normalized.indexOf('colour') !== -1)) {
        colorOptionIndex = index;
      }
    });

    if ((product.variants || []).length === 1) {
      thumbnails.push(customFpBuildThumb(customFpVariantImage(product.variants[0], product, true), product.title, true));
    } else if (colorOptionIndex > -1) {
      (product.variants || []).forEach(function(variant) {
        var colorValue = variant.options && variant.options[colorOptionIndex];
        if (!colorValue || seenColors[colorValue]) {
          return;
        }

        var imageSrc = customFpVariantImage(variant, product, false);
        if (!imageSrc) {
          return;
        }

        seenColors[colorValue] = true;
        if (thumbnails.length < 4) {
          thumbnails.push(customFpBuildThumb(imageSrc, product.title + ' - ' + colorValue, thumbnails.length === 0));
        }
      });
    }

    var imageMarkup = featuredImage ? '<img class="custom-fp-card__image" src="' + customFpEscapeHtml(featuredImage) + '" srcset="' + customFpEscapeHtml(customFpImageSrcset(featuredImage)) + '" sizes="(max-width: 768px) 50vw, 25vw" loading="lazy" alt="' + customFpEscapeHtml(product.title) + '" data-custom-fp-main-image>' : '';
    var badgeMarkup = onSale ? '<span class="custom-fp-card__badge">Sale</span>' : '';
    var priceMarkup = '<span class="custom-fp-card__price-current">' + customFpFormatMoney(price) + '</span>';
    if (onSale) {
      priceMarkup += '<span class="custom-fp-card__price-was">' + customFpFormatMoney(compareAtPrice) + '</span>';
    }

    return [
      '<div class="grid__item custom-fp-card custom-fp-card--pinned small--one-half medium-up--one-quarter" data-product-handle="' + customFpEscapeHtml(product.handle) + '" data-product-id="' + customFpEscapeHtml(product.id) + '">',
      '<div class="custom-fp-card__inner">',
      '<a class="custom-fp-card__image-link" href="' + customFpEscapeHtml(productUrl) + '" aria-label="' + customFpEscapeHtml(product.title) + '">' + imageMarkup + badgeMarkup + '</a>',
      '<div class="custom-fp-card__body">',
      '<a class="custom-fp-card__title" href="' + customFpEscapeHtml(productUrl) + '">' + customFpEscapeHtml(product.title) + '</a>',
      '<div class="custom-fp-card__price">' + priceMarkup + '</div>',
      thumbnails.length ? '<div class="custom-fp-card__variants" aria-label="Available colours">' + thumbnails.join('') + '</div>' : '',
      '</div></div></div>'
    ].join('');
  }

  function customFpPinCard() {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('fp');
    if (!handle) {
      return;
    }

    var grid = document.querySelector('.custom-fp-product-grid');
    if (!grid) {
      return;
    }

    var escapedHandle = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"');
    var existingCard = grid.querySelector('[data-product-handle="' + escapedHandle + '"]');
    if (existingCard) {
      existingCard.classList.add('custom-fp-card--pinned');
      grid.insertBefore(existingCard, grid.firstElementChild);
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Product not found');
        }
        return response.json();
      })
      .then(function(product) {
        if (!product || !product.handle) {
          return;
        }

        grid.insertAdjacentHTML('afterbegin', customFpBuildProductCard(product));
      })
      .catch(function(error) {
        console.warn('Custom FP product could not be pinned:', handle, error);
      });
  }

  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-custom-fp-thumb]');
    if (!thumb) {
      return;
    }

    var card = thumb.closest('.custom-fp-card');
    if (!card) {
      return;
    }

    var image = card.querySelector('[data-custom-fp-main-image]');
    if (!image) {
      return;
    }

    var src = thumb.getAttribute('data-image-src');
    var srcset = thumb.getAttribute('data-image-srcset');
    if (src) {
      image.setAttribute('src', src);
    }
    if (srcset) {
      image.setAttribute('srcset', srcset);
    }

    card.querySelectorAll('[data-custom-fp-thumb]').forEach(function(item) {
      item.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', customFpPinCard);
  } else {
    customFpPinCard();
  }

  } catch(e) { console.error(e); }
})();
})();
